<script>
export default {
  name: "AssetIcon",
  functional: true,
  props: {
    icon: {
      type: String,
      default: "",
    },
  },
  render(h, context) {
    const { icon } = context.props;
    const vnodes = [];

    if (icon) {
      if (icon.includes("el-icon")) {
        vnodes.push(<i class={[icon]} />);
      } else {
        vnodes.push(<icon class="asset-icon" theme="filled" />);
      }
    }
    return vnodes;
  },
};
</script>

<style scoped lang="scss">
.asset-icon {
  position: relative;
  top: 3px;

  ::v-deep > svg {
    width: 16px;
    height: 16px;
  }
}
</style>
